import { useParams, useNavigate } from "react-router-dom";
import useAxiosPrivate from "./useAxiosPrivate";
import useAuth from "./useAuth";

function DeletePlan() {
    const navigate = useNavigate();
    const params = useParams();
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axiosPrivate.delete(`/plans/${params.planId}`, {headers: {Authorization: "Bearer " + auth.accessToken}});
            navigate("/plans");
        } catch(err) {
            console.log(err);
        }
    }

    return (
        <form onSubmit={handleSubmit} className="bg-white rounded-lg border border-gray-300 p-6 shadow-md">
            <p className="text-gray-700 text-lg font-semibold mb-4">Are you sure you want to delete this plan?</p>
            <div className="flex justify-end">
                <button
                    type="submit"
                    className="bg-red-500 text-white px-4 py-2 rounded-lg font-bold hover:bg-red-600 shadow-md transition"
                >
                    Delete
                </button>
            </div>
        </form>
    )
}

export default DeletePlan;